import { render } from "./DailyLimit.vue?vue&type=template&id=6091b975&ts=true"
import script from "./DailyLimit.vue?vue&type=script&lang=ts"
export * from "./DailyLimit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__